import React from 'react';
import noop from 'lodash/noop';
import gettext from '@eb/gettext';
import {
    NOTIFICATION_TYPE_MAIN,
    NOTIFICATION_TYPE_FOCUS_PANEL,
} from './constants';
import {
    getDialogProps,
    handleSaveAction,
} from '@eb/eds-confirm-navigation-dialog';
import { TYPE_ERROR } from '@eb/eds-notification';

import { AlertChunky } from '@eb/eds-iconography';

export const getNotificationFunction = (
    type,
    structureMain,
    structureFocusPanel,
) => {
    const TYPE_TO_FUNCTION = {
        [NOTIFICATION_TYPE_MAIN]: structureMain,
        [NOTIFICATION_TYPE_FOCUS_PANEL]: structureFocusPanel,
    };

    return TYPE_TO_FUNCTION[type] || noop;
};

export const getNotificationProps = (errorMessage, additionalProps = {}) => ({
    type: TYPE_ERROR,
    children:
        errorMessage ||
        gettext('Please fill out all of the required fields correctly'),
    iconType: <AlertChunky />,
    ...additionalProps,
});

export const resolveFormHooks = (setDialogProps, handleSubmit, reset) =>
    new Promise((performNextAction, cancelNextAction) => {
        const closeDialog = () => setDialogProps(null);
        const onDiscard = () => {
            closeDialog();
            reset();
            performNextAction();
        };
        const onClose = () => {
            closeDialog();
            cancelNextAction();
        };
        const onSuccessfulSave = () => {
            closeDialog();
            performNextAction();
        };
        const onSave = () => {
            closeDialog();

            return handleSaveAction(handleSubmit, onSuccessfulSave, onClose);
        };

        setDialogProps(getDialogProps(onDiscard, onClose, onSave));
    });
